import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { blogPosts } from '../data/mockData';

const Media = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="pt-32 pb-16 px-6 lg:px-12 bg-cream">
        <div className="container mx-auto text-center">
          <span className="text-gold text-lg md:text-xl font-bold tracking-widest uppercase">
            SPOTLIGHT
          </span>
          <h1 className="mt-6 font-cormorant text-5xl md:text-7xl text-navy">
            What's happening in the<br />community and the chamber?
          </h1>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20 px-6 lg:px-12">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <Link
                key={post.id}
                to={`/post/${post.id}`}
                className="group cursor-pointer"
              >
                <article className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center text-xs text-gold font-bold tracking-wider uppercase mb-3">
                      <Calendar size={14} className="mr-2" />
                      {post.date}
                    </div>
                    <h2 className="font-cormorant text-2xl md:text-3xl text-navy mb-3 group-hover:text-gold transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-gray-600 text-sm leading-relaxed line-clamp-3">
                      {post.excerpt}
                    </p>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Media;
